<div class="av-form-container">

  <form nz-form [formGroup]="form" [nzLayout]="'vertical'">

    <div class="form-section">
      <!-- <div class="section-header">
        <h3 class="section-title">Audio Requirements</h3>
      </div> -->

      <div class="three-col-grid">
        <nz-form-item>
          <nz-form-label>Microphones</nz-form-label>
          <nz-form-control nzErrorTip="Please select microphones">
            <nz-select nzShowSearch nzAllowClear formControlName="microphone" nzPlaceHolder="Select microphones"
              nzMode="multiple" [ngClass]="{'bold-value': isView}">
              <nz-option *ngFor="let v of microphonesResponseModel.value.results" [nzValue]="v.id" [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>Speakers & Audio Output</nz-form-label>
          <nz-form-control nzErrorTip="Please select speakers & audio output">
            <nz-select nzShowSearch nzAllowClear formControlName="speakers_audio_output"
              nzPlaceHolder="Select speakers & audio output" nzMode="multiple" [ngClass]="{'bold-value': isView}">
              <nz-option *ngFor="let v of speakerAndAudioResponseModel.value.results" [nzValue]="v.id"
                [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>Audio Equipment</nz-form-label>
          <nz-form-control nzErrorTip="Please select audio equipment">
            <nz-select nzShowSearch nzAllowClear formControlName="audio_equipment"
              nzPlaceHolder="Select audio equipment" nzMode="multiple" [ngClass]="{'bold-value': isView}">
              <nz-option *ngFor="let v of audioEquipmentAudioResponseModel.value.results" [nzValue]="v.id"
                [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>Support Infrastructure</nz-form-label>
          <nz-form-control nzErrorTip="Please select support infrastructure">
            <nz-select nzShowSearch nzAllowClear formControlName="support_infra"
              nzPlaceHolder="Select support infrastructure" nzMode="multiple" [ngClass]="{'bold-value': isView}">
              <nz-option *ngFor="let v of supportInfraResponseModel.value.results" [nzValue]="v.id" [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>AV Staffing</nz-form-label>
          <nz-form-control nzErrorTip="Please select AV staffing">
            <nz-select nzShowSearch nzAllowClear formControlName="av_staff" nzPlaceHolder="Select AV staffing"
              nzMode="multiple" [ngClass]="{'bold-value': isView}">
              <nz-option *ngFor="let v of avStaffingResponseModel.value.results" [nzValue]="v.id" [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <nz-form-item>
        <nz-form-label>Audio Requirements Note</nz-form-label>
        <nz-form-control>
          <textarea nz-input formControlName="audio_requirements_note" placeholder="Enter audio requirements note"
            [nzAutosize]="{ minRows: 3, maxRows: 5 }" [ngClass]="{'bold-value': isView}"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>

    <!-- Video Requirements Section -->
    <div class="form-section">
      <div class="section-header">
        <h3 class="section-title">Video Requirements</h3>
      </div>

      <div class="three-col-grid">
        <nz-form-item>
          <nz-form-label>Display Systems</nz-form-label>
          <nz-form-control nzErrorTip="Please select Display Systems">
            <nz-select nzShowSearch nzAllowClear formControlName="display_units" nzPlaceHolder="Select Display Systems"
              nzMode="multiple" [ngClass]="{'bold-value': isView}">
              <nz-option *ngFor="let v of displayUnitsResponseModel.value.results" [nzValue]="v.id" [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>Cameras & Recording</nz-form-label>
          <nz-form-control nzErrorTip="Please select cameras & recording">
            <nz-select nzShowSearch nzAllowClear formControlName="cameras_recording"
              nzPlaceHolder="Select cameras & recording" nzMode="multiple" [ngClass]="{'bold-value': isView}">
              <nz-option *ngFor="let v of camerasAndRecordingResponseModel.value.results" [nzValue]="v.id"
                [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>Video Equipment</nz-form-label>
          <nz-form-control nzErrorTip="Please select video equipment">
            <nz-select nzShowSearch nzAllowClear formControlName="video_equipment"
              nzPlaceHolder="Select video equipment" nzMode="multiple" [ngClass]="{'bold-value': isView}">
              <nz-option *ngFor="let v of videoEquipmentsResponseModel.value.results" [nzValue]="v.id"
                [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <nz-form-item>
        <nz-form-label>Video Requirements Note</nz-form-label>
        <nz-form-control>
          <textarea nz-input formControlName="video_requirements_note" placeholder="Enter video requirements note"
            [nzAutosize]="{ minRows: 3, maxRows: 5 }" [ngClass]="{'bold-value': isView}"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>

    <!-- Lighting Requirements Section -->
    <div class="form-section">
      <div class="section-header">
        <h3 class="section-title">Lighting Requirements</h3>
      </div>

      <div class="three-col-grid lighting-two-col-grid">
        <nz-form-item>
          <nz-form-label>Stage Lighting</nz-form-label>
          <nz-form-control nzErrorTip="Please select Stage Lighting">
            <nz-select nzShowSearch nzAllowClear formControlName="general_stage_lighting"
              nzPlaceHolder="Select Stage Lighting" nzMode="multiple" [ngClass]="{'bold-value': isView}">
              <nz-option *ngFor="let v of stageLightingResponseModel.value.results" [nzValue]="v.id" [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>Ambient & Decorative Lighting</nz-form-label>
          <nz-form-control nzErrorTip="Please select Ambient & Decorative Lighting">
            <nz-select nzShowSearch nzAllowClear formControlName="special_lighting"
              nzPlaceHolder="Select Ambient & Decorative Lighting" nzMode="multiple" [ngClass]="{'bold-value': isView}">
              <nz-option *ngFor="let v of specialLightingResponseModel.value.results" [nzValue]="v.id"
                [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>Rigging & Support</nz-form-label>
          <nz-form-control nzErrorTip="Please select rigging & support">
            <nz-select nzShowSearch nzAllowClear formControlName="rigging_support"
              nzPlaceHolder="Select rigging & support" nzMode="multiple" [ngClass]="{'bold-value': isView}">
              <nz-option *ngFor="let v of riggingAndSupportResponseModel.value.results" [nzValue]="v.id"
                [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>Lighting Control</nz-form-label>
          <nz-form-control nzErrorTip="Please select lighting control">
            <nz-select nzShowSearch nzAllowClear formControlName="lighting_control"
              nzPlaceHolder="Select lighting control" nzMode="multiple" [ngClass]="{'bold-value': isView}">
              <nz-option *ngFor="let v of lightingControlResponseModel.value.results" [nzValue]="v.id"
                [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <nz-form-item>
        <nz-form-label>Lighting Requirements Note</nz-form-label>
        <nz-form-control>
          <textarea nz-input formControlName="lighting_requirements_note" placeholder="Enter lighting requirements note"
            [nzAutosize]="{ minRows: 3, maxRows: 5 }" [ngClass]="{'bold-value': isView}"></textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control>
          <button nz-button nzType="primary" (click)="onSave()" [disabled]="form.invalid">
            Submit
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>

  </form>
</div>
<style>
  .bold-value .ant-select-selection-item {
    font-weight: bold !important;
  }
</style>